<template>
    <div class="orderDetail">
<!--        <el-card class="noprint">-->
<!--            <el-page-header @back="goBack" :content="'订单详情('+ orderId + ')'"></el-page-header>-->
<!--        </el-card>-->
        <main class="content">
            <el-card>
                 <el-table
                    :data="proData"
                    v-loading="loading"
                    size="mini">
                     <el-table-column prop="sku" label="商品编码" fixed="left" width="150"/>
                     <el-table-column label="产品名称" width="200">
                        <template slot-scope="scope">
                             ({{scope.row.supplier}}) {{scope.row.shortName ? scope.row.shortName : scope.row.name}}
                         </template>
                     </el-table-column>
                     <el-table-column prop="brand" label="品牌" align="center" width="160"/>
                     <el-table-column prop="model" label="规格型号" align="center" width="160"/>
                     <el-table-column prop="num" label="数量" align="center" width="120">
                         <template slot-scope="scope">
                             {{scope.row.unit === null ? scope.row.num+'件' : scope.row.num+scope.row.unit}}
                         </template>
                     </el-table-column>
                     <el-table-column
                        min-width="160"
                        prop="untaxedPrice"
                        label="未税单价(元)"
                        align="center">
                            <template slot-scope="scope">
                                {{scope.row.untaxedPrice}}
                            </template>
                     </el-table-column>
                    <el-table-column
                        min-width="160"
                        prop="price"
                        label="含税单价(元)"
                        align="center">
                        <template slot-scope="scope">
                            {{scope.row.price}}
                        </template>
                    </el-table-column>
                     <el-table-column
                        min-width="160"
                             prop="totalUntaxedPrice"
                             label="未税总价(元)"
                             align="center">
                         <template slot-scope="scope">
                             {{scope.row.totalUntaxedPrice}}
                         </template>
                     </el-table-column>
                    <el-table-column
                        min-width="160"
                        prop="totalPrice" label="含税总价(元)" align="center">
                        <template slot-scope="scope">
                            {{scope.row.totalPrice}}
                        </template>
                    </el-table-column>
                     <el-table-column prop="orderMemo" label="备注" align="center" width="200"/>
                    <el-table-column
                            fixed="right" prop="status" label="状态" align="center">
                         <template slot-scope="scope">
                             <el-tag v-if="scope.row.status == 0" size="mini">待下单</el-tag>
                             <el-tag v-if="scope.row.status == 2" size="mini">已下单</el-tag>
                             <el-tag v-if="scope.row.status == 3" size="mini">已发货</el-tag>
                             <el-tag v-if="scope.row.status == 4" size="mini">已收货</el-tag>
                             <el-tag v-if="scope.row.status == 7" size="mini">驳回</el-tag>
                         </template>
                     </el-table-column>
                     <el-table-column label="操作" align="center" fixed="right" width="160">
                         <template slot-scope="scope">
                             <el-button size="mini" @click="pushPMS(scope.row.id)" type="text">推送PMS</el-button>
                         </template>
                     </el-table-column>
                </el-table>
            </el-card>
        </main>
    </div>
</template>
<script>

export default {
    data() {
        return {
            id:"",
            loading: false,
            total: 0,
            pageSize: 10,
            currentPage: 1,
            tableData: [],
            reviewVisible:false,
            numVisible:false,
            reviewForm: {
                name:"",//收货人
                pass:true,
                reason: "",
                workflowId:"",
                step:"",
                orderId:"",
                totalPrice:"",
                price:"",
                all:true//整个订单 false :单条订单
            },
            itemForm: {
                detailId:"",//
                workflowId:"",
                step:"",
                orderId:"",
                num:"",
                oldNum:"",
                unit:"件"
            },
            infoData:{},
            invoiceData: [],//发票信息
            deliverData: [],//发票及货物接收信息
            orderData:[],//销售订单
            taxData: [],//含税价格
            proData: [],//产品信息
            submitReason: "",
            rules: {
                num: [
                    {required: true, message: '请输入数量', trigger: 'blur'}
                ],
            }
        }
    },

    methods: {
        info() {
            const url = "/admin/rfq/orderInfo";
            if(this.orderId) {
                this.loading = true;
                let that = this
                this.$axios.post(url,{orderId:this.orderId}).then(function(response) {
                    let resp = response.data;
                    if(resp.header.status == 0) {
                        that.infoData = resp.data;
                        that.proData = that.infoData.orderDetails;
                    }
                }).catch(function() {
                }).finally(() => {
                    that.loading = false;
                });
            }
        },
        pushPMS(id) {
            const that  = this;
            this.$confirm('单独推送商品可能导致重复下单，是否确定推送?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$axios.post("/admin/product/order/pushOrderDetail2PMS",{id})
                .then(function(response) {
                    let resp = response.data;
                    if(resp.header.status == 0) {
                        that.$notify({
                            title: '成功',
                            message: '已推送PMS',
                            type: 'success'
                        });
                    } else {
                        that.$notify.error({
                            title: '错误',
                            message: resp.header.msg
                        });
                    }
                }).catch(function() {
                }).finally(() => {
                    that.loading = false;
                });
            });
        },
        goBack() {
            this.$router.go(-1);
        },
    },
    created() {
        let paramsStore;
        const params = sessionStorage.getItem("params");
        if(params) {
            paramsStore = JSON.parse(params);
        }
        const { id } = JSON.stringify(this.$route.params)== "{}"?paramsStore:this.$route.params;
        this.orderId = id;
        this.info();
    },


}
</script>
<style lang="scss" scoped>
    // .tableBaseInfo{
    //     font-size: 13px !important;
    // }


</style>